import React from 'react';
import { motion } from 'framer-motion';
import SectionHeading from '../components/ui/SectionHeading';
import SafeIcon from '../common/SafeIcon';
import { pressMentions } from '../data/content';

const Press = () => {
  return (
    <div className="pt-24 min-h-screen bg-white dark:bg-brand-dark transition-colors duration-300 relative overflow-hidden">
      {/* Dark Grid Background */}
      <div 
        className="absolute top-0 left-0 w-full h-[600px] opacity-[0.15] dark:opacity-[0.25] pointer-events-none" 
        style={{ 
          backgroundImage: 'linear-gradient(to right, #40E0D0 1px, transparent 1px), linear-gradient(to bottom, #40E0D0 1px, transparent 1px)', 
          backgroundSize: '48px 48px',
          maskImage: 'radial-gradient(circle at center, transparent 0%, black 85%)',
          WebkitMaskImage: 'radial-gradient(circle at center, transparent 0%, black 85%)'
        }}
      ></div>
      
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24 relative z-10">
        <SectionHeading title="Media & Insights" subtitle="Press & Speaking" />
        
        <p className="text-lg text-slate-600 dark:text-slate-400 font-medium mb-16 max-w-3xl">
          Explore recent podcast appearances, keynote presentations, and published articles detailing my strategic methodologies for Setting the Stage for SUCCESS.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {pressMentions.map((item, index) => (
            <motion.div 
              key={item.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className="group bg-slate-50 dark:bg-slate-900/50 rounded-2xl overflow-hidden shadow-sm hover:shadow-2xl transition-all duration-500 border border-slate-200 dark:border-slate-800 flex flex-col"
            >
              <div className="aspect-[16/9] overflow-hidden relative">
                <div className="absolute inset-0 bg-brand-cyan/20 opacity-0 group-hover:opacity-100 transition-opacity z-10 mix-blend-multiply"></div>
                <img src={item.image} alt={item.title} className="w-full h-full object-cover filter grayscale-[40%] group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700" />
                <div className="absolute top-4 left-4 z-20">
                  <span className="bg-brand-dark text-brand-yellow text-[10px] uppercase tracking-widest px-3 py-1 font-bold rounded-full shadow-lg border border-brand-yellow/30">
                    {item.type}
                  </span>
                </div>
              </div>
              <div className="p-8 flex-grow flex flex-col">
                <div className="flex items-center gap-2 text-xs font-bold text-slate-400 mb-3 uppercase tracking-widest">
                  <SafeIcon name="Calendar" className="w-3 h-3" /> {item.date}
                </div>
                <h3 className="text-xl font-heading font-bold text-brand-dark dark:text-white mb-2 group-hover:text-brand-cyan transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm font-bold text-brand-red dark:text-brand-yellow mb-6">
                  {item.publisher}
                </p>
                <a 
                  href={item.link} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="mt-auto inline-flex items-center gap-2 text-xs uppercase font-bold tracking-widest text-brand-dark dark:text-white hover:text-brand-red dark:hover:text-brand-cyan transition-colors w-max"
                >
                  View Feature <SafeIcon name="ArrowRight" className="w-4 h-4" />
                </a>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Media Kit CTA */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mt-24 p-10 md:p-16 text-center bg-brand-dark dark:bg-brand-darker text-white rounded-3xl relative overflow-hidden border border-brand-cyan/20"
        >
          <div 
            className="absolute inset-0 opacity-[0.2]" 
            style={{ 
              backgroundImage: 'linear-gradient(to right, #40E0D0 1px, transparent 1px), linear-gradient(to bottom, #40E0D0 1px, transparent 1px)', 
              backgroundSize: '40px 40px',
              maskImage: 'radial-gradient(circle at center, transparent 0%, black 80%)',
              WebkitMaskImage: 'radial-gradient(circle at center, transparent 0%, black 80%)'
            }}
          ></div>
          <div className="relative z-10">
            <h3 className="text-3xl font-heading font-bold mb-4">Request Media Kit</h3>
            <p className="text-slate-300 mb-8 max-w-2xl mx-auto font-medium text-lg">
              For speaking engagements, podcast interviews, or expert commentary on marketing operations and brand positioning.
            </p>
            <a 
              href="mailto:julie@sevenhats.com?subject=Media%20Inquiry"
              className="inline-flex items-center gap-2 px-8 py-4 bg-brand-red text-white text-sm uppercase font-bold tracking-widest hover:bg-brand-yellow hover:text-brand-dark transition-colors rounded-lg shadow-xl shadow-brand-red/20"
            >
              Contact Press Team <SafeIcon name="Mail" className="w-4 h-4" />
            </a>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Press;